"use client";

import { useState } from "react";
import Comparison from "@/components/preview/comparison";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import { Button } from "@/components/ui/button";
import { MeasurementBadge } from "../measurement";

function PlusSvg({ strokeWidth }: { strokeWidth: number }) {
  return (
    <svg
      aria-hidden="true"
      className="size-4 shrink-0 text-gray-1100"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3V13M3 8H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

function IconButton({
  showStroke,
  strokeWidth,
}: {
  showStroke: boolean;
  strokeWidth: number;
}) {
  return (
    <div className="relative flex items-center justify-center">
      <MeasurementBadge
        className="top-1/2 right-full mr-2.5 origin-right -translate-y-1/2"
        show={showStroke}
        variant="sky"
      >
        {strokeWidth}px
      </MeasurementBadge>
      <Button
        leftIcon={<PlusSvg strokeWidth={strokeWidth} />}
        rounded
        size="md"
        type="button"
        variant="secondary"
      >
        New project
      </Button>
    </div>
  );
}

export default function UiIconStrokeDemo() {
  const [showStroke, setShowStroke] = useState(false);

  return (
    <Comparison
      bad={<IconButton showStroke={showStroke} strokeWidth={1} />}
      footer={
        <DemoCheckbox
          checked={showStroke}
          label="Show stroke width"
          onCheckedChange={setShowStroke}
        />
      }
      good={<IconButton showStroke={showStroke} strokeWidth={1.5} />}
      panelClassName="h-44"
      stackBelow="sm"
    />
  );
}
